var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-modal",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.closed_requested.apply(null, arguments)}}},[_c('dialog',{staticClass:"base-modal--body",attrs:{"open":""},on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }